module.exports = __webpack_public_path__ + "img/image03.5a0184a3.jpg";